// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app.en .section[data-v-43d3e98d].center-first {\n  min-width: 420px;\n}\n#app.en .section[data-v-43d3e98d].center-two {\n  width: 442px;\n}\n#app.en .section[data-v-43d3e98d].center-three {\n  min-width: 364px;\n}\n#app.en .section[data-v-43d3e98d].center-four {\n  width: 310px;\n}\n", ""]);
// Exports
module.exports = exports;
